module.exports = __webpack_public_path__ + "static/media/monis.png:Zone.dce51917.Identifier";